// React
import { useContext, useEffect, useState } from "react";

// Components
import {
	Card,
	Grid,
	Hidden,
	Icon,
	Tooltip,
	Select,
	MenuItem,
	FormControl,
	InputLabel,
	ToggleButtonGroup,
	ToggleButton,
	Badge,
} from "@mui/material";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import DataTable from "components/Tables/DataTable";
import SinDatos from "components/Carteles/SinDatos";
import SoftInput from "components/SoftInput";
import ModalProveedores from "./ModalProveedores";
import { UserContext } from "context/user";
import ModalAdministrarPedido from "./components/AdministrarPedido";
import dataCompras from "./data";
import { gql, useMutation, useQuery } from "@apollo/client";
import Loading from "components/Carteles/Loading";
import CustomPagination from "components/Pagination";
import { MenuContext } from "context/menuContext";
import { getUproColor } from "utils/colors";
import { ConfirmarContext } from "context/ConfirmarContext";
import { MessageManager } from "context";
import ModalSearchProvision from "./components/AdministrarPedido/ModalBuscarProvision";
import ModalSolicitarEntregaProveedor from "./components/ModalSolicitarEntregaProveedor";
import ModalHistorialEntregas from "./components/ModalHistorialEntregas";
import {
	PERMISOS_COMPRAS,
	esGestorCompras,
	PERMISOS_SOLICITAR_EN_COMPRAS,
	tienePermisoCompras,
} from "./permisos";

function Compras() {
	const [openModalProveedores, setOpenModalProveedores] = useState(false);
	const [openModalSolicitudEntrega, setOpenModalSolicitudEntrega] = useState(false);
	const [openModalHistorialEntregas, setOpenModalHistorialEntregas] = useState(false);
	const [selectedRemito, setSelectedRemito] = useState(null);
	const [hayPendientes, setHayPendientes] = useState(false);
	const [openModalAdministrar, setOpenModalAdministrar] = useState(false);
	const [selected, setSelected] = useState(null);
	const { verificarAcceso, user: currentUser } = useContext(UserContext);
	const [openFilters, setOpenFilters] = useState(false);
	const [licitacionInicio, setlicitacionInicio] = useState(null);
	const [licitacionFin, setlicitacionFin] = useState(null);
	const { menu } = useContext(MenuContext);
	const { confirmar } = useContext(ConfirmarContext);
	const { handleSnackbar } = useContext(MessageManager);
	const { columns, getRows } = dataCompras;
	const [rows, setRows] = useState([]);
	const [search, setSearch] = useState("");
	const [searchTimeout, setSearchTimeout] = useState(null);
	const [page, setPage] = useState(1);
	const [prioritario, setPrioritario] = useState(false);
	const [openSelectProvision, setOpenSelectProvision] = useState(false);
	const [selectedProvision, setSelectedProvision] = useState();
	const [pagesInfo, setPagesInfo] = useState({
		pages: 0,
		total: 0,
	});
	const [order, setOrder] = useState({
		campo: "id",
		orden: "DESC",
	});

	const formatDate = (date) => {
		if (!date) return null;
		const d = new Date(date);
		d.setHours(0, 0, 0, 0);
		const year = d.getFullYear();
		const month = String(d.getMonth() + 1).padStart(2, "0");
		const day = String(d.getDate()).padStart(2, "0");
		const hours = String(d.getHours()).padStart(2, "0");
		const minutes = String(d.getMinutes()).padStart(2, "0");
		const seconds = String(d.getSeconds()).padStart(2, "0");

		return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
	};

	const formatDateEnd = (date) => {
		if (!date) return null;
		const d = new Date(date);
		d.setHours(23, 59, 59, 999);
		const year = d.getFullYear();
		const month = String(d.getMonth() + 1).padStart(2, "0");
		const day = String(d.getDate()).padStart(2, "0");
		const hours = String(d.getHours()).padStart(2, "0");
		const minutes = String(d.getMinutes()).padStart(2, "0");
		const seconds = String(d.getSeconds()).padStart(2, "0");

		return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
	};

	const [licitacionEstado, setLicitacionEstado] = useState({});

	const { data, loading, refetch } = useQuery(
		gql`
      query getPedidosComprasCompras(
        $filter: JSON
        $pagination: PaginationInput
        $order: [Order]
        $search: String
        $prioritario: AreaExpedienteEnum
      ) {
        paginationInfo {
          pages
          total
        }
        pedidosCompra(filter: $filter, pagination: $pagination, order: $order, search: $search, prioritario: $prioritario) {
          id
          nombre
          tipoCompra
          numeroExpediente
          estado
          licitacionEstado
          createdAt
          subtotalEstimado
          motivoAnulacion
          fechaAnulacion
          lastEstadoUpdated
          estadoBase {
            nombre
            area
          }
        }
      }
    `,
		{
			variables: {
				pagination: {
					page: page,
					limit: 10,
				},
				order: [{ field: order.campo, order: order.orden }],
				search: search,
				filter: {
					licitacionInicio: licitacionInicio ? { _gte: formatDate(licitacionInicio) } : undefined,
					licitacionFin: licitacionFin ? { _lte: formatDateEnd(licitacionFin) } : undefined,
					...licitacionEstado,
				},
				prioritario: prioritario ? "Compras" : undefined,
			},
			fetchPolicy: "no-cache",
		}
	);

	const [mutate, { loading: loadingMutation }] = useMutation(gql`
    mutation savePedidoCompraCompras($input: PedidoCompraInput!) {
      savePedidoCompra(input: $input) {
        id
      }
    }
  `);

	useEffect(() => {
		if (data?.pedidosCompra) {
			setRows(getRows(data.pedidosCompra, handleOpenMenu));
			setPagesInfo(data.paginationInfo);
		}
	}, [data]);

	const handleLicitacionEstadoChange = (event) => {
		const { value } = event.target;
		switch (value) {
			case "Finalizada":
				setLicitacionEstado({
					licitacionFinalizada: { _not: null },
				});
				break;
			case "No iniciada":
				setLicitacionEstado({
					licitacionInicio: null,
				});
				break;
			case "Cerrada":
				setLicitacionEstado({
					licitacionFin: { _lte: new Date() },
					licitacionFinalizada: null,
				});
				break;
			case "En curso":
				setLicitacionEstado({
					licitacionInicio: { _lte: new Date() },
					licitacionFin: { _gte: new Date() },
				});
				break;
			case "Programada":
				setLicitacionEstado({
					licitacionInicio: { _gte: new Date() },
				});
				break;
			case "Anulada":
				setLicitacionEstado({
					fechaAnulacion: { _not: null },
				});
				break;
			case "Todos":
				setLicitacionEstado({});
				break;
			default:
				return undefined;
		}
	};
	useEffect(() => {
		refetch();
	}, [licitacionEstado, licitacionInicio, licitacionFin, search]);

	const toggleFilters = () => {
		if (openFilters) {
			setlicitacionInicio(null);
			setlicitacionFin(null);
			setLicitacionEstado({});
		}
		setOpenFilters(!openFilters);
	};

	const handleOpenMenu = (e, item) => {
		menu({
			open: e.target,
			align: "right",
			options: [
				{
					name: "Ver expediente",
					onClick: () => {
						setOpenModalAdministrar(true);
						setSelected(item);
					},
					disabled: false,
					hidden: !verificarAcceso(PERMISOS_SOLICITAR_EN_COMPRAS, "or") || item.fechaAnulacion,
					icon: { icon: "rule", color: getUproColor("uproGreen") },
				},
				{
					name: "Anular",
					onClick: () => {
						confirmar({
							icon: "warning",
							title: "Anular pedido",
							message: `¿Está seguro que desea anular el pedido #${item.id}?`,
							pedirMotivo: true,
							placeholder: "Ingrese el motivo de la anulación",
							func: async (motivo) => {
								try {
									await mutate({
										variables: {
											input: {
												id: item.id,
												motivoAnulacion: motivo,
											},
										},
									});
									handleSnackbar("Pedido anulado correctamente", "success");
									refetch();
								} catch (error) {
									handleSnackbar("Error al anular el pedido, intente más tarde", "error");
								}
							},
						});
					},
					hidden: !tienePermisoCompras(currentUser, verificarAcceso, PERMISOS_COMPRAS.ANULAR_REACTIVAR_PEDIDO) || item.fechaAnulacion,
					disabled: ["Finalizada", "Cerrada"].includes(item.licitacionEstado),
					icon: { icon: "close", color: "error" },
				},
				{
					name: "Activar",
					onClick: () => {
						confirmar({
							icon: "arrow_circle_up",
							title: "Activar pedido",
							message: `¿Está seguro que desea reactivar el pedido #${item.id}?`,
							func: async () => {
								try {
									await mutate({
										variables: {
											input: {
												id: item.id,
												motivoAnulacion: null,
											},
										},
									});
									handleSnackbar("Pedido activado correctamente", "success");
									refetch();
								} catch (error) {
									handleSnackbar("Error al anular el pedido, intente más tarde", "error");
								}
							},
						});
					},
					hidden: !tienePermisoCompras(currentUser, verificarAcceso, PERMISOS_COMPRAS.ANULAR_REACTIVAR_PEDIDO) || !item.fechaAnulacion,
					icon: { icon: "arrow_circle_up", color: getUproColor("uproGreen") },
				},
			],
		});
	};

	const handleSearch = (event) => {
		const newTimeout = setTimeout(() => {
			setSearch(event.target.value);
			setPage(1);
		}, 500);
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}
		setSearchTimeout(newTimeout);
	};

	const handleOrder = (campo) => {
		if (order.campo === campo) {
			if (order.orden === "ASC") {
				setOrder({
					campo: campo,
					orden: "DESC",
				});
			} else {
				setOrder({
					campo: campo,
					orden: "ASC",
				});
			}
		} else {
			setOrder({
				campo: campo,
				orden: "ASC",
			});
		}
	};

	return (
		<DashboardLayout>
			<DashboardNavbar />
			<SoftBox py={3}>
				<SoftBox mb={3}>
					<Card>
						<Grid container spacing={2} p={2}>
							<Grid item xs={12}>
								<SoftBox
									display={{
										xs: "flex-row",
										sm: "flex",
									}}
									justifyContent="space-between"
									alignItems="center"
								>
									<SoftBox display="flex" alignItems="center" gap={1}>
										<Icon fontSize="medium" sx={{ color: getUproColor("uproPink") }}>
											receipt
										</Icon>
										<SoftTypography variant="h6">Expedientes</SoftTypography>
									</SoftBox>
									<SoftBox display="flex" justifyContent="flex-end" alignItems="center" gap={1}>
										<SoftBox>
											<Tooltip
												title={openFilters ? "Cerrar filtros" : "Ver Más filtros"}
												placement="top"
											>
												<SoftButton color="uproGreen" onClick={toggleFilters} circular iconOnly>
													<Icon sx={{ fontWeight: "bold" }}>
														{openFilters ? "filter_alt_off" : "filter_alt"}
													</Icon>
												</SoftButton>
											</Tooltip>
										</SoftBox>
										{openFilters && (
											<SoftBox display="flex" alignItems="center" gap={1} mt={-1.8}>
												<SoftBox>
													<SoftTypography variant="caption" color="secondary" display="block">
														Fecha de Inicio
													</SoftTypography>
													<Tooltip title="Filtro fecha de inicio" placement="top">
														<SoftInput
															type="date"
															value={licitacionInicio || ""}
															onChange={(e) => setlicitacionInicio(e.target.value)}
															placeholder={!licitacionInicio ? "Fecha de inicio" : ""}
														/>
													</Tooltip>
												</SoftBox>
												<SoftBox>
													<SoftTypography variant="caption" color="secondary" display="block">
														Fecha de Fin
													</SoftTypography>
													<Tooltip title="Filtro fecha de fin" placement="top">
														<SoftInput
															type="date"
															value={licitacionFin || ""}
															onChange={(e) => setlicitacionFin(e.target.value)}
															placeholder={!licitacionFin ? "Fecha de fin" : ""}
														/>
													</Tooltip>
												</SoftBox>
												<SoftBox>
													<SoftTypography variant="caption" color="secondary" display="block">
														Estado
													</SoftTypography>
													<Tooltip title="Filtrar por estado de licitación" placement="top">
														<FormControl variant="outlined" sx={{ minWidth: 120 }}>
															<Select
																onChange={handleLicitacionEstadoChange}
																label="Estado"
																defaultValue="Todos"
															>
																<MenuItem value="Todos">Todos</MenuItem>
																<MenuItem value="Finalizada">Finalizada</MenuItem>
																<MenuItem value="No iniciada">No Iniciada</MenuItem>
																<MenuItem value="Cerrada">Cerrada</MenuItem>
																<MenuItem value="En curso">En Curso</MenuItem>
																<MenuItem value="Programada">Programada</MenuItem>
																<MenuItem value="Anulada">Anulada</MenuItem>
															</Select>
														</FormControl>
													</Tooltip>
												</SoftBox>
											</SoftBox>
										)}
										<SoftBox display="flex" gap={1}>
											<Tooltip title="Solicitar a proveedores la entrega de productos" placement="top">
												<SoftButton
													color="uproPink"
													iconOnly
													onClick={() => {
														setOpenModalSolicitudEntrega(true);
													}}
													circular
												>
													<Icon sx={{ fontWeight: "light" }}>email</Icon>
												</SoftButton>
											</Tooltip>

											<Tooltip title="Solicitudes de entrega / Calendario" placement="top">
												<SoftButton
													color="info"
													iconOnly
													onClick={() => {
														setOpenModalHistorialEntregas(true);
													}}
												>
													<Icon sx={{ fontWeight: "light" }}>history</Icon>
													<Icon sx={{ fontWeight: "light" }}>calendar_today</Icon>
												</SoftButton>
											</Tooltip>
										</SoftBox>
										{verificarAcceso(30) && (
											<SoftBox display="flex" alignItems="center">
												<Tooltip title="Administrar proveedores" placement="top">
													<SoftButton
														color="uproYellow"
														iconOnly
														onClick={() => setOpenModalProveedores(true)}
														circular
													>
														<Icon sx={{ fontWeight: "light" }}>group</Icon>
													</SoftButton>
												</Tooltip>
												{hayPendientes && (
													<Tooltip title="Documentación pendiente">
														<Icon
															sx={{
																position: "absolute",
																ml: 3.5,
																mt: -2,
																fontSize: "1rem",
																color: getUproColor("uproPink"),
															}}
														>
															new_releases
														</Icon>
													</Tooltip>
												)}
											</SoftBox>
										)}
										<SoftInput
											placeholder="Buscar..."
											icon={{ component: "search", direction: "left" }}
											onChange={handleSearch}
										/>
										{verificarAcceso(PERMISOS_SOLICITAR_EN_COMPRAS, "or") && (
											<>
												<SoftBox>
													<Tooltip title="Administrar solicitudes" placement="top">
														<SoftButton
															color="uproPink"
															onClick={() => setOpenModalAdministrar(true)}
															circular
														>
															<Icon sx={{ fontWeight: "light" }}>add</Icon>
															&nbsp;Nuevo pedido
														</SoftButton>
													</Tooltip>
												</SoftBox>
												<SoftBox
													display="flex"
													alignItems="center"
													justifyContent="center"
													flexDirection="column"
													gap={2}
													py={4}
												>
													<SoftButton
														color="primary"
														circular
														onClick={() => setOpenSelectProvision(true)}
													>
														Buscar OP&nbsp;<Icon>arrow_outward</Icon>
													</SoftButton>
												</SoftBox>
											</>
										)}
									</SoftBox>
								</SoftBox>
							</Grid>
						</Grid>
						<SoftBox>
							{loading ? (
								<Loading />
							) : rows?.length > 0 ? (
								<DataTable columns={columns} rows={rows} order={order} setOrder={handleOrder} />
							) : (
								<SinDatos />
							)}
						</SoftBox>
						<CustomPagination
							loading={loading}
							length={data?.pedidosCompra?.length}
							total={pagesInfo?.total}
							pages={pagesInfo?.pages}
							page={page}
							setPage={setPage}
							noCard
						/>
					</Card>
					<ModalAdministrarPedido
						open={openModalAdministrar}
						handleClose={() => {
							setOpenModalAdministrar(false);
							setSelected(null);
						}}
						refetchParent={refetch}
						id={selected?.id}
						mode={esGestorCompras(currentUser, verificarAcceso) ? "Compras" : "Solicitante"}
					/>
					<ModalProveedores
						open={openModalProveedores}
						handleClose={() => setOpenModalProveedores(false)}
						onPendientesDetected={(hayPendientes) => {
							setHayPendientes(hayPendientes);
						}}
					/>
					<ModalSearchProvision
						open={openSelectProvision}
						handleClose={() => setOpenSelectProvision(false)}
						setSelection={(item) => {
							setSelectedProvision(item);
							setOpenSelectProvision(false);
						}}
					/>
					<ModalSolicitarEntregaProveedor
						open={openModalSolicitudEntrega}
						handleClose={() => {
							setOpenModalSolicitudEntrega(false);
							setSelectedRemito(null);
						}}
						selectedRemito={selectedRemito}
						idSucursal={1}
						refetchProductos={() => { }}
					/>

					<ModalHistorialEntregas
						open={openModalHistorialEntregas}
						handleClose={() => setOpenModalHistorialEntregas(false)}
					/>
				</SoftBox>
			</SoftBox>
			<Footer />
		</DashboardLayout>
	);
}

export default Compras;
